import React, { useState, useEffect } from 'react';
import { getRulerConfig, updateRulerConfig } from '../core/subscriptionService';
import { useToast } from '../../components/Toats';

export const RulerConfig: React.FC = () => {
  const { toggleToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [config, setConfig] = useState({
    open_charge_days_before: 5,
    move_to_default_days_after: 3,
    move_to_suspended_days: 15,
    move_to_cancelled_days: 30,
    auto_open_charge: true,
    auto_move_to_default: true,
    auto_move_to_suspended: true,
    auto_move_to_cancelled: false,
    standalone_charge_ruler: false,
  });

  useEffect(() => {
    getRulerConfig().then((data) => {
      if (data) {
        setConfig({
          open_charge_days_before: data.open_charge_days_before ?? 5,
          move_to_default_days_after: data.move_to_default_days_after ?? 3,
          move_to_suspended_days: data.move_to_suspended_days ?? 15,
          move_to_cancelled_days: data.move_to_cancelled_days ?? 30,
          auto_open_charge: data.auto_open_charge ?? true,
          auto_move_to_default: data.auto_move_to_default ?? true,
          auto_move_to_suspended: data.auto_move_to_suspended ?? true,
          auto_move_to_cancelled: data.auto_move_to_cancelled ?? false,
          standalone_charge_ruler: data.standalone_charge_ruler ?? false,
        });
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setConfig((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : Number(value),
    }));
  };

  const handleSave = () => {
    setSaving(true);
    updateRulerConfig(config).then(() => {
      setSaving(false);
      toggleToast('Régua de inadimplência salva com sucesso!', 'success');
    }).catch((err: any) => {
      toggleToast(err?.response?.data?.message || err?.response?.data?.error || 'Erro ao salvar configuração.', 'error');
      setSaving(false);
    });
  };

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0 cursor-pointer' role='button' data-bs-toggle='collapse' data-bs-target='#kt_account_ruler_config'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Régua de Inadimplência</h3>
        </div>
      </div>

      <div id='kt_account_ruler_config' className='collapse show'>
        <div className='card-body border-top p-9'>
          {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Carregando...</span>
              </div>
            </div>
          ) : (
            <div className='row mb-8'>
              <div className='col-lg-6'>
                <div className='d-flex flex-stack mb-4'>
                  <div className='d-flex align-items-center'>
                    <div className='form-check form-check-solid form-switch form-check-custom fv-row me-4'>
                      <input className='form-check-input w-45px h-30px' type='checkbox' name='auto_open_charge' checked={config.auto_open_charge} onChange={handleChange} />
                      <label className='form-check-label'></label>
                    </div>
                    <div className='d-flex flex-column'>
                      <span className='fw-bolder text-gray-800 fs-5'>Gerar Fatura Antecipada</span>
                      <span className='text-muted fw-bold'>Gera a cobrança automaticamente antes do ciclo</span>
                    </div>
                  </div>
                  <div className='w-100px'>
                    <div className='input-group input-group-sm'>
                      <input type='number' className='form-control form-control-solid text-end' name='open_charge_days_before' value={config.open_charge_days_before} onChange={handleChange} />
                      <span className='input-group-text'>dias</span>
                    </div>
                  </div>
                </div>

                <div className='d-flex flex-stack mb-4'>
                  <div className='d-flex align-items-center'>
                    <div className='form-check form-check-solid form-switch form-check-custom fv-row me-4'>
                      <input className='form-check-input w-45px h-30px' type='checkbox' name='auto_move_to_default' checked={config.auto_move_to_default} onChange={handleChange} />
                      <label className='form-check-label'></label>
                    </div>
                    <div className='d-flex flex-column'>
                      <span className='fw-bolder text-gray-800 fs-5'>Mover para Inadimplente</span>
                      <span className='text-muted fw-bold'>Muda status após o vencimento</span>
                    </div>
                  </div>
                  <div className='w-100px'>
                    <div className='input-group input-group-sm'>
                      <input type='number' className='form-control form-control-solid text-end' name='move_to_default_days_after' value={config.move_to_default_days_after} onChange={handleChange} />
                      <span className='input-group-text'>dias</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-lg-6'>
                <div className='d-flex flex-stack mb-4'>
                  <div className='d-flex align-items-center'>
                    <div className='form-check form-check-solid form-switch form-check-custom fv-row me-4'>
                      <input className='form-check-input w-45px h-30px' type='checkbox' name='auto_move_to_suspended' checked={config.auto_move_to_suspended} onChange={handleChange} />
                      <label className='form-check-label'></label>
                    </div>
                    <div className='d-flex flex-column'>
                      <span className='fw-bolder text-gray-800 fs-5'>Suspender Assinatura</span>
                      <span className='text-muted fw-bold text-danger'>Bloqueia o serviço do cliente após atraso prolongado</span>
                    </div>
                  </div>
                  <div className='w-100px'>
                    <div className='input-group input-group-sm'>
                      <input type='number' className='form-control form-control-solid text-end' name='move_to_suspended_days' value={config.move_to_suspended_days} onChange={handleChange} />
                      <span className='input-group-text'>dias</span>
                    </div>
                  </div>
                </div>

                <div className='d-flex flex-stack mb-4'>
                  <div className='d-flex align-items-center'>
                    <div className='form-check form-check-solid form-switch form-check-custom fv-row me-4'>
                      <input className='form-check-input w-45px h-30px' type='checkbox' name='auto_move_to_cancelled' checked={config.auto_move_to_cancelled} onChange={handleChange} />
                      <label className='form-check-label'></label>
                    </div>
                    <div className='d-flex flex-column'>
                      <span className='fw-bolder text-gray-800 fs-5'>Cancelar Assinatura</span>
                      <span className='text-muted fw-bold'>Cancela o contrato permanentemente (irreversível)</span>
                    </div>
                  </div>
                  <div className='w-100px'>
                    <div className='input-group input-group-sm'>
                      <input type='number' className='form-control form-control-solid text-end' name='move_to_cancelled_days' value={config.move_to_cancelled_days} onChange={handleChange} disabled={!config.auto_move_to_cancelled} />
                      <span className='input-group-text'>dias</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-lg-12'>
                <div className='separator separator-dashed my-6'></div>
                <div className='d-flex flex-stack mb-4'>
                  <div className='d-flex align-items-center'>
                    <div className='form-check form-check-solid form-switch form-check-custom fv-row me-4'>
                      <input className='form-check-input w-45px h-30px' type='checkbox' name='standalone_charge_ruler' checked={config.standalone_charge_ruler} onChange={handleChange} />
                      <label className='form-check-label'></label>
                    </div>
                    <div className='d-flex flex-column'>
                      <span className='fw-bolder text-gray-800 fs-5'>Aplicar régua em cobranças avulsas</span>
                      <span className='text-muted fw-bold'>As regras de inadimplência também serão aplicadas para cobranças avulsas (não vinculadas a assinaturas)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type='button' className='btn btn-primary' onClick={handleSave} disabled={saving || loading}>
            {saving ? <span className='spinner-border spinner-border-sm align-middle ms-2'></span> : 'Salvar Alterações'}
          </button>
        </div>
      </div>
    </div>
  );
};
